import { useEffect } from "react";
import Sacrifice from "@/pages/Sacrifice";

/**
 * Hidden `/kms` landing route.
 *
 * Renders the existing Legacy Challenge page verbatim — same signup form,
 * same leaderboard/wall/tracker/donation flow — but sets a session flag
 * so any child component can adjust cross-links (e.g. the "Shop merch"
 * button routes to /kms/shop instead of /shop).
 *
 * No login. No password. The route just isn't linked from the public nav.
 */
export default function KmsLanding() {
  useEffect(() => {
    try {
      window.sessionStorage.setItem("kms_access", "1");
    } catch { /* private mode */ }
  }, []);
  return <Sacrifice kmsMode />;
}
